import { environment } from './utils/constants';

const IS_PRODUCTION = process.env.NODE_ENV === 'production';

const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';

const _dwb_env_ = (window as any)._dossier_workbench_env_;

const currentUrl = window.location.href;

let url = environment.backendUrlExternal;

if (currentUrl.startsWith('https://eps')) {
    url = environment.backendUrl;
}

if (currentUrl.startsWith('http://localhost')) {
    url = 'https://eps.apps-staging.epo.org/publication-server';
}

if (currentUrl.startsWith('https://p-pins') || currentUrl.startsWith('https://p-epslod') || currentUrl.startsWith('https://np-pins')) {
    url = environment.backendUrlInternal;
}

const BACKEND_URL = `${url}`;

const PUBLIC_URL = _dwb_env_ ? _dwb_env_.REACT_APP_PUBLIC_URL : process.env.PUBLIC_URL;

const DEV_TOKEN = process.env.REACT_APP_DEV_TOKEN;

export { PUBLIC_URL, BACKEND_URL, IS_PRODUCTION, IS_DEVELOPMENT, DEV_TOKEN };
